import { useEffect, useState } from 'react';
import { getAircraft } from '../../api';
import { useFeedback } from '../../hooks/useFeedback';
import { getApiErrorMessage } from '../../utils/apiError';
import { formatMetric } from '../../utils/formatMetric';
import '../modal/ModalBase.css';
import ModalOverlay from '../modal/ModalOverlay';
import ModalPortal from '../modal/ModalPortal';
import './FuelOilModal.css';

type Props = {
  onClose: () => void;
};

const FuelOilModal = ({ onClose }: Props) => {
  const { showError, feedbackNode } = useFeedback();
  const [actualFuel, setActualFuel] = useState<number | null>(null);
  const [oilLph, setOilLph] = useState<number | null>(null);
  const [oilQph, setOilQph] = useState<number | null>(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let cancelled = false;
    const load = async () => {
      try {
        const res = await getAircraft();
        if (cancelled) return;
        setActualFuel(res.data.actual_fuel_burn_lph ?? null);
        setOilLph(res.data.oil_burn_lph ?? null);
        setOilQph(res.data.oil_burn_qph ?? null);
      } catch (error) {
        if (!cancelled) {
          showError(getApiErrorMessage(error, 'Не удалось загрузить расход'));
        }
      } finally {
        if (!cancelled) setLoading(false);
      }
    };
    void load();
    return () => {
      cancelled = true;
    };
  }, [showError]);

  return (
    <ModalPortal>
      <ModalOverlay onClose={onClose}>
        {feedbackNode}
        <div
          className="modal fuel-oil-modal"
          onClick={(e) => e.stopPropagation()}
        >
          <h3>Расход топлива и масла</h3>
          <div className="fuel-oil-tiles">
            <div className="fuel-oil-tile">
              <span className="fuel-oil-tile-label">Средний расход топлива</span>
              <span className="fuel-oil-tile-value">
                <span className="fuel-oil-tile-number">
                  {loading ? '…' : formatMetric(actualFuel)}
                  {!loading && actualFuel != null ? (
                    <span className="fuel-oil-tile-unit">л/ч</span>
                  ) : null}
                </span>
              </span>
            </div>

            <div className="fuel-oil-tile">
              <span className="fuel-oil-tile-label">Расход масла</span>
              <span className="fuel-oil-tile-value">
                <span className="fuel-oil-tile-number">
                  {loading ? '…' : formatMetric(oilLph, 3)}
                  {!loading && oilLph != null ? (
                    <span className="fuel-oil-tile-unit">л/ч</span>
                  ) : null}
                </span>
              </span>
              {!loading && oilQph != null ? (
                <span className="fuel-oil-tile-alt">
                  {formatMetric(oilQph, 3)} кв/ч
                </span>
              ) : null}
            </div>
          </div>
        </div>
      </ModalOverlay>
    </ModalPortal>
  );
};

export default FuelOilModal;
